import { Loader2 } from 'lucide-react'

import { Button } from 'src/shared/components/ui/buttons/button'
import { cn } from 'src/shared/utils/cn'

export interface FooterItem {
  variant: 'icon-text' | 'link-button'
  icon?: React.ReactNode
  text?: string
  onClick?: () => void
}

function FooterItem({ variant, icon, text, onClick }: FooterItem) {
  if (variant === 'icon-text') {
    return (
      <div className="flex flex-row items-center gap-3 text-sm leading-[1.6] text-primary">
        {icon}
        <span className="line-clamp-3">{text}</span>
      </div>
    )
  }

  return (
    <div
      onClick={onClick}
      className={cn('p-2 pl-0 text-[15px] font-semibold text-primary underline', onClick && 'cursor-pointer')}
    >
      {text}
    </div>
  )
}

interface ULFooterProps {
  buttonText?: string
  buttonVariant?: 'default' | 'ghost'
  isLoading?: boolean
  isPrimaryDisabled?: boolean
  primaryAction?: () => void
  bottomLeftContent?: FooterItem
}

const ULFooter = ({
  buttonText = 'Continue',
  buttonVariant = 'default',
  isLoading = false,
  isPrimaryDisabled = false,
  primaryAction,
  bottomLeftContent,
}: ULFooterProps) => {
  return (
    <div className="absolute inset-x-0 bottom-0 flex h-[80px] w-full flex-row items-center justify-between gap-5 rounded-b-[20px] border-t border-lightBorder bg-white p-5">
      {bottomLeftContent ? (
        <FooterItem {...bottomLeftContent} />
      ) : (
        <div> {/* empty div, dont remove, used for spacing */} </div>
      )}
      <div className="flex flex-row items-center gap-4">
        <Button
          variant={buttonVariant}
          size="sm"
          className={cn(
            'h-[50px] rounded-full px-8 text-[15px] font-semibold xs:min-w-[200px]',
            buttonVariant === 'ghost' && 'border border-primary',
          )}
          form={primaryAction ? undefined : 'business-create-form'}
          type={primaryAction ? 'button' : 'submit'}
          onClick={primaryAction}
          disabled={isLoading || isPrimaryDisabled}
        >
          {isLoading ? <Loader2 className="size-4 animate-spin" /> : buttonText}
        </Button>
      </div>
    </div>
  )
}

export default ULFooter
